import React, { useEffect, useState } from 'react';
import { Game } from '../../types/types';
import _ from 'underscore';
import { BuildPerformanceRows, LocationPerformanceTable, TeamPerformanceTable } from '../../globals/TableFunctions';
import TableContainer from '../Tables/TableContainer';
import PlayerDataGrid from '../DataGrid/PlayerDataGrid';
import { DataGrid, GridColDef, GridValueGetterParams, GridCellParams, GridRowParams, GridEventListener, GridEvents, MuiEvent, GridCallbackDetails } from '@mui/x-data-grid';
import PerformanceSelectedGames from './PerformanceSelectedGames';
import Fade from '../Theming/NewFadein';
import MyTransition from '../Theming/MyTransition';

export interface Props {
    games: Game[];
}

const PERFORMANCE_ITEMS = [
    'wickets',
    'runs', 
    'points',
    'maiden_overs',
    'fours',
];

function SinglePlayerPerformance({games}:Props) {
    console.log("SinglePlayerPerformance: ", games);
    const [ locationRows, setLocationRows ] = useState([]);
    const [ oppositionRows, setOppositionRows ] = useState([]);
    const [ selectedGames, setSelectedGames] = useState([]);
    const [ selectedGamesTableName, setSelectedGamesTableName ] = useState("");
    const [selectedType, setSelectedType ] = useState("");

    useEffect(() => {
        BuildLocation();
        BuildTeam();
    }, [ games ])
    
    function BuildLocation() {
        let locationGroups = _.groupBy(games,'location');
        let result = BuildPerformanceItems(locationGroups);
        let newresult = BuildPerformanceRows(result);
        setLocationRows(newresult);
    }

    function BuildTeam() { 
        let teamGroups = _.groupBy(games, function(game) {
            return game.opposition?.name? game.opposition.name : '';
        });
        let result = BuildPerformanceItems(teamGroups);
        let newresult = BuildPerformanceRows(result);
        setOppositionRows(newresult);
    }

    function BuildPerformanceItems(groups) {
        let result = _.mapObject(groups,function(val, key) {
            let res = {games: val.length};
            PERFORMANCE_ITEMS.map(function(pi) { res[pi] = 0});
            val.map(function(game:Game) {
                PERFORMANCE_ITEMS.map(function(pi) { 
                    if (pi === 'wickets') {
                        res[pi] = res[pi] + game[pi]/20;
                    } else {
                        res[pi] = res[pi] + game[pi];
                    }
                    
                });
            });          
            PERFORMANCE_ITEMS.map(function(pi) {
                let theresult = (res[pi] / val.length).toFixed(2);
                res[pi] = theresult;
            });
            return res    
        });
        return result;
    }

    function FilterGames(type:string,value:string) {
        let filteredGames = []
        if (type === 'location') {
            filteredGames = games.filter(function(game) {
                if (game.location === value) {
                    return game;
                }
            });
        } else if (type === 'opposition') {
            filteredGames = games.filter(function(game) {
                if (game.opposition.name === value) {
                    return game;
                }
            });
        }
        setSelectedGames(filteredGames);
    }

    function OnCellClick(params: GridCellParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails, type: string) {
        console.log("On Cell Click: ", params,event,details, type)
        FilterGames(type,params.row.name);
        setSelectedGamesTableName(`Performance ${type === 'location' ? '@' : 'against'} ${params.row.name}`);
        setSelectedType(type);
    }

    return <div style={{display: "flex", flexDirection: "column", rowGap: "1rem"}}>
        <MyTransition location="tab2">
            <TableContainer header='Performance By Venue'>
            <PlayerDataGrid
                columns={LocationPerformanceTable}
                rows={locationRows}
                height={500}
                onCellClick={(params,event,details) => OnCellClick(params,event,details,'location')}
            />
        </TableContainer>
        </MyTransition>
        {selectedGames.length > 0 && selectedType === 'location' ? <PerformanceSelectedGames games={selectedGames} title={selectedGamesTableName}/> : null}

        <TableContainer header='Performance By Opposition'>
            <PlayerDataGrid
                columns={TeamPerformanceTable}
                rows={oppositionRows}
                height={500}
                onCellClick={(params,event,details) => OnCellClick(params,event,details,'opposition')}
            />
        </TableContainer>
        {selectedGames.length > 0 && selectedType === 'opposition' ? <PerformanceSelectedGames games={selectedGames} title={selectedGamesTableName}/> : null }
    </div>

}

export default SinglePlayerPerformance;